module.exports = fox._r("images/halloween/gift-150.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/halloween/gift-150.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/halloween/gift-150.png
// module id = 374
// module chunks = 4